import { render, staticRenderFns } from "./Notification.vue?vue&type=template&id=33744148"
import script from "./Notification.vue?vue&type=script&lang=js"
export * from "./Notification.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('33744148')) {
      api.createRecord('33744148', component.options)
    } else {
      api.reload('33744148', component.options)
    }
    module.hot.accept("./Notification.vue?vue&type=template&id=33744148", function () {
      api.rerender('33744148', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "components/material/Notification.vue"
export default component.exports